import React from "react";
import { MemoryRouter, Router as ReactRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import NEFThemeProvider from "@nef/style-utils";
import { CookiesProvider } from "react-cookie";
import { NotificationHub } from "@nef/core";
import { createBrowserHistory } from "history";

import { GlobalModal } from "../context/modal-context";
import { BookmarkProvider } from "../context/bookmark-context";
import { UserProvider } from "../context/user-context";
import { UTMProvider } from "../context/utm-context";
import { AnnouncementsProvider } from "../context/announcements-context";

import PageMetadata from "./page-metadata";
import { AuthProvider } from "./authentication";

interface ApplicationProviderInterface {
  children: JSX.Element;
  isTest?: boolean;
  initialEntries?: string[];
}

const history = createBrowserHistory();

const Router = ({
  children,
  isTest,
  initialEntries
}: ApplicationProviderInterface) => {
  return (
    <>
      {isTest ? (
        <MemoryRouter initialEntries={initialEntries}>{children}</MemoryRouter>
      ) : (
        <ReactRouter history={history}>{children}</ReactRouter>
      )}
    </>
  );
};

const ApplicationProvider = ({
  children,
  isTest = false,
  initialEntries
}: ApplicationProviderInterface) => {
  return (
    <>
      <NEFThemeProvider mode="lightWithDarkSidebar">
        <Router isTest={isTest} initialEntries={initialEntries}>
          <HelmetProvider>
            <PageMetadata metadataKey="application" />
            <CookiesProvider>
              <>
                <AuthProvider>
                  <AnnouncementsProvider>
                    <UTMProvider>
                      <GlobalModal>
                        <BookmarkProvider>
                          <UserProvider>{children}</UserProvider>
                          <NotificationHub />
                        </BookmarkProvider>
                      </GlobalModal>
                    </UTMProvider>
                  </AnnouncementsProvider>
                </AuthProvider>
              </>
            </CookiesProvider>
          </HelmetProvider>
        </Router>
      </NEFThemeProvider>
    </>
  );
};

export default ApplicationProvider;
